import { getVatValueInPercent } from '../../config/vat';

export const getPriceWithVat = (priceWithoutVat: number): number => {
    return priceWithoutVat + priceWithoutVat * (getVatValueInPercent() / 100);
};
